import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../shared/shared.module';
import { TemplateContentComponent } from './template-content.component';

@NgModule({
  declarations: [TemplateContentComponent],
  imports: [CommonModule, SharedModule, RouterModule],
  exports: [TemplateContentComponent],
})
export class TemplateContentModule {}
